import { encodeAbiParameters, encodeFunctionData } from 'viem';
/**
 * ERC7821 execution mode for a single batch without opData support.
 * Bytes Layout:
 * - [0]      ( 1 byte )  0x01 for batch call
 * - [1]      ( 1 byte )  0x00 for revert on any failure
 * - [2..5]   ( 4 bytes)  Reserved by ERC7579
 * - [6..9]   ( 4 bytes)  0x00000000
 * - [10..31] (22 bytes)  Unused
 */
export const MODE_SINGLE_BATCH = '0x0100000000000000000000000000000000000000000000000000000000000000';
/**
 * ABI for the ERC7821 execute function
 */
const erc7821ExecuteAbi = [
    {
        name: 'execute',
        type: 'function',
        inputs: [
            { name: 'mode', type: 'bytes32' },
            { name: 'executionData', type: 'bytes' },
        ],
        outputs: [],
    },
];
/**
 * ABI parameters for encoding the calls array
 */
const callsAbiType = [
    {
        type: 'tuple[]',
        components: [
            { name: 'to', type: 'address' },
            { name: 'value', type: 'uint256' },
            { name: 'data', type: 'bytes' },
        ],
    },
];
/**
 * Encodes an ERC7821 execute call for a batch of calls.
 * Uses MODE_SINGLE_BATCH which executes all calls and reverts if any fail.
 *
 * @param calls - Array of calls to execute
 * @returns Encoded calldata for the execute function
 */
export function encodeERC7821Execute(calls) {
    // Normalize calls with default value of 0n
    const normalizedCalls = calls.map((call) => ({
        to: call.to,
        value: call.value ?? 0n,
        data: call.data,
    }));
    // Encode the calls array as the execution data
    const executionData = encodeAbiParameters(callsAbiType, [normalizedCalls]);
    // Encode the full execute function call
    return encodeFunctionData({
        abi: erc7821ExecuteAbi,
        functionName: 'execute',
        args: [MODE_SINGLE_BATCH, executionData],
    });
}
